module.exports = __webpack_public_path__ + "img/uk-lung-cancer-male.3ac1ced3.png";